/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TransitionEnums {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3
}
